<template>
    <div class="prijava">

        <template v-if="pageState == 'success'">
            <successScreen></successScreen>
        </template>

        <template v-if="pageState == 'error'">
            <errorScreen v-on:close_overlay="resetState"></errorScreen>
        </template>

        <!-- navbar -->
        <Navbar></Navbar>

        <div class="container cf">
            <!-- counter pitanja -->
            <div class="counter">
                <TurnInCounter v-on:turninfinished="turnInAnswers"></TurnInCounter>
            </div>

            <div>
                <div class="bonus">
                    <span class="pic icon-cup"></span>
                    <p class="name"> Želiš li Bonus bodove? </p>
                    <p> Mudro iskoristi jokere! U tijeku jedne sezone možeš iskoristiti 3 jokera, a u svakom kolu možeš koristiti samo jedan.</p>
                    <ul class="cf">
                        <li @click.prevent="setBonusType('times_three')" :class="{'alpha': usedBonusTimesThree}">
                            <a href="#" v-bind:class="{'active': bonusType == 'times_three'}">
                                <strong>
                                    <template v-if="!usedBonusTimesThree">3x bodovanje</template>
                                    <template v-if="usedBonusTimesThree">Joker iskorišten</template>
                                </strong>

                                <span>
                                    Odaberi jedno pitanje i utrostruči broj bodova. Ovaj joker možeš iskoristiti samo jednom u sezoni!
                                </span>

                            </a>
                        </li>
                        <li @click.prevent="setBonusType('wild_card')" :class="{'alpha': usedBonusWildCard}">
                            <a href="#" v-bind:class="{'active': bonusType == 'wild_card'}" >
                                <strong>
                                    <template v-if="!usedBonusWildCard">Wild card</template>
                                    <template v-if="usedBonusWildCard">Joker iskorišten</template>
                                </strong>

                                <span>
                                    Odaberi jedno pitanje za koje misliš da si pogrešno odgovorio,
                                    a Toni će ga priznati kao točno. Pametno odaberi!
                                </span>
                            </a>
                        </li>
                        <li @click.prevent="setBonusType('plus_30_seconds')" class="m-top" :class="{'alpha': usedBonusPlus30Seconds}">
                            <a href="#" v-bind:class="{'active': bonusType == 'plus_30_seconds'}" >
                                <strong>
                                    <template v-if="!usedBonusPlus30Seconds">+30 sekundi</template>
                                    <template v-if="usedBonusPlus30Seconds">Joker iskorišten</template>
                                </strong>

                                <span>
                                    Ovim jokerom dobivaš 30 sekundi i dodatnih bodova po svakom
                                    točno odgovorenom pitanju.
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <p class="loading" v-if="loading">Učitavanje odgovora...</p>
                <ul class="cards">
                    <PrijavaPitanjaSingle v-for="(userAnswer, questionKey) in userAnswers"
                    v-bind:key="questionKey"
                    :questionKey="questionKey"
                    :bonusType="bonusType"
                    :userAnswer="userAnswer"
                    :setMultiplier="setMultiplier"
                    :multiplier="userAnswer.multiplier"
                    :wildCard="userAnswer.wildCard"
                    :setWildCard="setWildCard"></PrijavaPitanjaSingle>
                </ul>

                <div class="button" @click.prevent="turnInAnswers">
                    <a href="#" class="button-1 red"><span>Završi/predaj kviz</span></a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import successScreen from '../components/SuccessScreen.vue'
import errorScreen from '../components/ErrorScreen.vue'
import TurnInCounter from '../components/TurnInCounter.vue'
import PrijavaPitanjaSingle from './PrijavaPitanjaSingle.vue'
import { ApplicationState } from '../application-state'
import { TimeUtils } from '../utils/timeUtils'
import { BonusType } from '../utils/bonusType'

const TurnInState = {
    TURNING_IN: 'turning_in',
    ERROR: 'error',
    SUCCESS: 'success'
}
export default {
    name: 'prijava',
    data: function () {
        return {
            pageState: TurnInState.TURNING_IN,
            bonusType: BonusType.NONE,
            loading: true,
            userAnswers: {},
            turningInAnswersInProgress: false
        }
    },
    components: {
        Navbar,
        successScreen,
        errorScreen,
        TurnInCounter,
        PrijavaPitanjaSingle
    },
    watch: {
        pageState (after) {
            if (after === TurnInState.SUCCESS) {
                setTimeout(() => {
                    this.$router.replace({ name: 'home' })
                }, 3000)
            }
        },
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadata()
            }
        }
    },
    computed: {
        appState () {
            return this.$store.state.appState
        },

        prevRound () {
            return this.$store.state.prevRound
        },

        usedBonusWildCard () {
            try {
                return this.$store.state.metadata.userData.usedBonus_wild_card
            } catch (error) {
                return true
            }
        },

        usedBonusTimesThree () {
            try {
                return this.$store.state.metadata.userData.usedBonus_times_three
            } catch (error) {
                return true
            }
        },

        usedBonusPlus30Seconds () {
            try {
                return this.$store.state.metadata.userData.usedBonus_plus_30_seconds
            } catch (error) {
                return true
            }
        },

        usedBonus () {
            try {
                return this.$store.state.metadata.userData.usedBonus
            } catch (error) {
                return true
            }
        },

        username () {
            try {
                return this.$store.state.metadata.userData.name
            } catch (error) {
                return 'Nepoznati korisnik'
            }
        },

        secondsToTurnIn () {
            try {
                return TimeUtils.timeUntilFutureTimestamp(this.$store.state.prevRound.endTime + this.$store.state.prevRound.timeToTurnIn)
            } catch (error) {
                return 0
            }
        }
    },
    methods: {
        clearBonusType () {
            for (let answer in this.userAnswers) {
                if (this.userAnswers.hasOwnProperty(answer)) {
                    const _questionKey = answer
                    answer = this.userAnswers[_questionKey]
                    answer.multiplier = false
                    answer.wildCard = false
                }
            }
        },

        setBonusType (bonusType) {
            try {
                if (this.$store.state.metadata.userData[`usedBonus_${bonusType}`]) return
            } catch (error) {
                console.error('used bonus')
            }

            this.clearBonusType()
            if (bonusType === this.bonusType) {
                this.bonusType = BonusType.NONE
            } else {
                this.bonusType = bonusType
            }
        },

        async getUserAnswers () {
            this.loading = true
            try {
                let serverUserAnswers = {}
                serverUserAnswers = await this.$db.answers.getUserAnswers()
                let questionNumber = 1
                this.userAnswers = {}
                for (let answer in serverUserAnswers) {
                    if (serverUserAnswers.hasOwnProperty(answer)) {
                        const _questionKey = answer
                        answer = serverUserAnswers[_questionKey]
                        this.$set(answer, 'wildCard', false)
                        this.$set(answer, 'multiplier', false)
                        answer.questionNumber = questionNumber++
                        this.$set(this.userAnswers, _questionKey, answer)
                    }
                }
            } catch (error) {
                console.error(error)
            }
            this.loading = false
        },

        setMultiplier (questionKey) {
            for (let answer in this.userAnswers) {
                if (this.userAnswers.hasOwnProperty(answer)) {
                    const _questionKey = answer
                    answer = this.userAnswers[_questionKey]
                    if (_questionKey !== questionKey) {
                        answer.multiplier = false
                    } else {
                        // answer.multiplier = !answer.multiplier
                        this.$set(answer, 'multiplier', !answer.multiplier)
                    }
                }
            }
        },

        setWildCard (questionKey) {
            for (let answer in this.userAnswers) {
                if (this.userAnswers.hasOwnProperty(answer)) {
                    const _questionKey = answer
                    answer = this.userAnswers[_questionKey]
                    if (_questionKey !== questionKey) {
                        answer.wildCard = false
                    } else {
                        this.$set(answer, 'wildCard', !answer.wildCard)
                    }
                }
            }
        },

        async turnInAnswers () {
            if (!this.turningInAnswersInProgress) {
                this.turningInAnswersInProgress = true
                let turnInAnswersRequest = {
                    quizKey: this.prevRound.quizKey,
                    bonusType: this.bonusType,
                    name: this.username,
                    answers: []
                }
                for (let answer in this.userAnswers) {
                    if (this.userAnswers.hasOwnProperty(answer)) {
                        const questionKey = answer
                        answer = this.userAnswers[questionKey]
                        turnInAnswersRequest.answers.push(
                            {
                                'questionKey': questionKey,
                                'multiplier': answer.multiplier,
                                'wildCard': answer.wildCard
                            })
                    }
                }
                await this.$db.answers.turnInAnswers(turnInAnswersRequest)
                this.sendGA()
                try {
                    this.$store.commit('setUsedBonusyType', this.bonusType)
                } catch (error) { }
                this.pageState = TurnInState.SUCCESS
                this.turningInAnswersInProgress = false
            }
        },

        sendGA () {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': `Bonus`,
                'event_label': `${this.bonusType}`
            })
        },

        resetState () {
            this.pageState = TurnInState.TURNING_IN
        },

        initialLoadata () {
            try {
                this.activateState = 'failed'
                if (this.secondsToTurnIn) {
                    this.getUserAnswers()
                } else {
                    this.$router.replace({ name: 'home' })
                }
            } catch (error) {}
        }
    },
    mounted () {
        this.loading = true
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.initialLoadata()
        }
    }

}
</script>

<style lang="scss" scoped>
.loading {
    display: block;
    position: relative;
    border-radius: 7px;
    padding: 11px 12px 54px;
    font-family: "mPlus";
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -.2px;
    color: #fff;
    text-align: center;
}
.prijava {
    padding-top: 14px;
    padding-bottom: 24px;
    text-align: left;

    .counter {
        margin-bottom: 64px;
    }
    .button {
        text-align: center;

        a {
            min-width: 248px;
        }
    }
    .title {
        font-family: "mPlus";
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -.2px;
        color: #fff;
        margin-bottom: 16px;
    }
    .text {
        font-family: "axiforma";
        font-size: 12px;
        line-height: 18px;
        letter-spacing: .3px;
        color: #fff;
        margin-bottom: 64px;
    }
    .bonus {
        position: relative;
        box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
        background-color: #fff;
        border-radius: 5px;
        padding: 54px 12px 9px;
        margin-top: 30px;
        margin-bottom: 90px;

        > p {
            line-height: 18px;
        }
        .pic {
            display: block;
            position: absolute;
            left: calc(50% - 40px);
            top: -30px;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 5px solid #fff;
            background-color: #fff;
            background-position: 50%;
            background-size: contain;
        }
        .name {
            text-align: center;
            font-family: "axiforma";
            font-size: 16px;
            letter-spacing: .3px;
            color: #000;
            margin-bottom: 10px;
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            margin-left: -12px;
            margin-bottom: -50px;

            li {
                float: left;
                width: 50%;
                padding-left: 12px;
                &.alpha {
                    opacity: .7;
                }
            }
            a {
                transition: opacity .4s ease-in-out;
                box-shadow: 0px 18px 40px 0px rgba(255,0,29,0.33);
                display: block;
                position: relative;
                border-radius: 7px;
                padding: 11px 12px 54px;
                font-family: "mPlus";
                font-size: 18px;
                line-height: 22px;
                letter-spacing: -.2px;
                background: linear-gradient(135deg, #ff0084 0%, #ff001d 100%);
                color: #fff;
                height: 100%;

                strong {
                    clear: both;
                    width: 100%;
                    display: block;
                }

                span {
                    font-family: "axiforma";
                    font-size: 12px;
                    line-height: 17px;
                    letter-spacing: .3px;
                }
                &:after {
                    content: '';
                    position: absolute;
                    left: calc(50% - 10.5px);
                    bottom: 19px;
                    width: 21px;
                    height: 21px;
                    background: url(~@/assets/img/icons/checkbox-2.png) 50% no-repeat;
                    background-size: contain;
                }
            }
            a.active:after {
                background: url(~@/assets/img/icons/checkbox-checked-2.png) 50% no-repeat;
                background-size: contain;
            }
        }
    }
    ul.cards {
        position: relative;
        margin-bottom: 30px;
    }
}
.m-top {
    margin-top: 20px;
}

@media only screen and (min-width: 800px) {
    .prijava {
        max-width: 1280px;
        margin: auto;
        .container {
            > div:nth-child(1) {
                float: left;
                width: 300px;
                padding-top: 30px;
            }
            > div:nth-child(2) {
                float: right;
                width: calc(100% - 332px);
            }
        }
        .bonus ul a:hover {
            opacity: 0.75;
        }
    }
}
@media only screen and (max-width: 480px) {
    .prijava {
        .bonus ul li {
            width: 100%;
            margin-bottom: 20px;
        }
        .bonus ul li.m-top {
            margin-top: 0;
        }
    }
}
</style>
